import React from 'react';

export default function ConstellationLogo() {
  return (
    <a className="navbar-brand d-flex align-items-center m-0 p-0" href="/" aria-label="Logo">
      <img src="/Constellation_RGB_Subheading.png" alt="Constellation" style={{ width: 'var(--brand-width)' }} />
    </a>
  );
}
